<div
  #designedSvgContainer
  class="designed-svg-container"
  [style.padding-bottom]="predicatedContainerPadding"></div>
